/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_New_RoundInputs */

const en_us2_clubs_new_round = /** @type {(inputs: Clubs_New_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New round`)
};

const pt_br2_clubs_new_round = /** @type {(inputs: Clubs_New_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova rodada`)
};

const es_419_clubs_new_round = /** @type {(inputs: Clubs_New_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva ronda`)
};

const pt_pt2_clubs_new_round = /** @type {(inputs: Clubs_New_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova ronda`)
};

const fr_fr2_clubs_new_round = /** @type {(inputs: Clubs_New_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle manche`)
};

const de_de2_clubs_new_round = /** @type {(inputs: Clubs_New_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Runde`)
};

const it_it2_clubs_new_round = /** @type {(inputs: Clubs_New_RoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo turno`)
};

/**
* | output |
* | --- |
* | "New round" |
*
* @param {Clubs_New_RoundInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_new_round = /** @type {((inputs?: Clubs_New_RoundInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_New_RoundInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_new_round(inputs)
	if (locale === "es-419") return es_419_clubs_new_round(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_new_round(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_new_round(inputs)
	if (locale === "de-DE") return de_de2_clubs_new_round(inputs)
	if (locale === "it-IT") return it_it2_clubs_new_round(inputs)
	return en_us2_clubs_new_round(inputs)
});
export { clubs_new_round as "clubs.new_round" }